exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-document-list__item{background-color:var(--theme-grey-bg);border-bottom:1px solid #a0a4b0}", ""]);

// exports
